export default {
    default: {
        fetchModelsPeriod: 30000, // définit le temps en ms entre chaque fetch
    },
    listModels: {
        users: {
            url: 'user/',
            fetch: false,
        },
        priceLists: {
            url: 'price-list/',
            fetch: false,
        },
        groups: {
            url: 'group/'
        },
        clients: {
            url: 'client/',
            fetch: false,
        },
        clientsCount: {
            url: 'client/',
            stats: true
        },
        simulationsCount: {
            url: 'simulation/',
            stats: true
        },
        bills: {
            url: 'bill/',
            fetch: false,
        },
        factories: {
            url: 'factory/',
            filters: {
                archived: false
            }
        },
        grantedAccessUser: {
            url: 'granted-access-user/',
            fetch: false
        },
        // unblockUsers: {
        //     url: 'blocked-users/',
        //     fetch: false
        // }
    },
};



// WEBPACK FOOTER //
// ./src/store/meta.js